import React, { useEffect, useState } from 'react';
import axios from 'axios';
import Breadcrumb from '../../core/common/Breadcrumb/breadcrumb';
import DriverSidebar from './sidebar';
import styles from "./Styles/DriverProfile.module.css";

import ProfileInfoTab from './profile/ProfileInfoTab';
import VehicleAvailabilityTab from './profile/VehicleAvailabilityTab';
import AssignedPackagesTab from './profile/AssignedPackagesTab';
import { MotoristaData, Disponibilidade } from "./profile/types";

const DriverProfileSettings = () => {
    const BASE_URL = process.env.REACT_APP_API_URL;
    const [motoristaData, setMotoristaData] = useState<MotoristaData | null>(null);
    const [disponibilidades, setDisponibilidades] = useState<Disponibilidade[]>([]);
    const [loading, setLoading] = useState(true);
    const [activeTab, setActiveTab] = useState<'profile' | 'veiculo' | 'pacotes'>('profile');

    useEffect(() => {
        const token = localStorage.getItem('token');

        axios.get(`${BASE_URL}/motorista/me`, {
            headers: { Authorization: `Bearer ${token}` }
        })
        .then(res => {
            const data: MotoristaData = res.data;

            setMotoristaData({
                ...data,
                dataExpedicao: data.dataExpedicao?.substring(0, 10) || '',
                dataValidade: data.dataValidade?.substring(0, 10) || '',
                fotoId: data.fotoId || null
            });

            // Busca disponibilidades apenas se o motorista tiver veículo
            if (data.veiculo?.veiculoId) {
                axios.get(`${BASE_URL}/motorista/disponibilidade`, {
                    headers: { Authorization: `Bearer ${token}` }
                })
                .then(res2 => setDisponibilidades(res2.data))
                .catch(err => console.error('Erro ao carregar disponibilidades', err))
                .finally(() => setLoading(false));
            } else {
                setLoading(false);
            }
        })
        .catch(err => {
            console.error('Erro ao carregar motorista', err);
            setLoading(false);
        });
    }, [BASE_URL]);

    if (loading) return <div>Loading...</div>;

    const formatDate = (dateStr: string) => {
        const d = new Date(dateStr);
        return d.toLocaleDateString(undefined, { day: '2-digit', month: 'short', year: 'numeric' });
    };

    return (
        <div>
            <Breadcrumb
                title="Driver Profile"
                breadcrumbs={[
                    { label: 'Dashboard', link: '/', active: false },
                    { label: 'Driver Profile', active: true },
                ]}
                backgroundClass="breadcrumb-bg-01"
            />

            <div className="content">
                <div className="container">
                    <div className="row">
                        <div className="col-xl-3 col-lg-4">
                            <DriverSidebar />
                        </div>

                        <div className="col-xl-9 col-lg-8">
                            {/* Tabs */}
                            <div className={styles.tabs}>
                                <button
                                    className={`${styles.tabButton} ${activeTab === 'profile' ? styles.activeTab : ''}`}
                                    onClick={() => setActiveTab('profile')}
                                >
                                    Profile Info
                                </button>
                                <button
                                    className={`${styles.tabButton} ${activeTab === 'veiculo' ? styles.activeTab : ''}`}
                                    onClick={() => setActiveTab('veiculo')}
                                >
                                    Vehicle & Availability
                                </button>
                                <button
                                    className={`${styles.tabButton} ${activeTab === 'pacotes' ? styles.activeTab : ''}`}
                                    onClick={() => setActiveTab('pacotes')}
                                >
                                    Assigned Packages
                                </button>
                            </div>

                            {/* Profile Info */}
                            {activeTab === 'profile' && motoristaData && (
                                <ProfileInfoTab
                                    motoristaData={motoristaData}
                                    BASE_URL={BASE_URL!}
                                    formatDate={formatDate}
                                />
                            )}

                            {/* Vehicle & Availability */}
                            {activeTab === 'veiculo' && motoristaData && (
                                <VehicleAvailabilityTab
                                    motoristaData={motoristaData}
                                    disponibilidades={disponibilidades}
                                    BASE_URL={BASE_URL!}
                                    formatDate={formatDate}
                                />
                            )}

                            {/* Assigned Packages */}
                            {activeTab === 'pacotes' && (
                                <AssignedPackagesTab BASE_URL={BASE_URL!} />
                            )}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default DriverProfileSettings;